import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export interface SearchBarProps {
  setSearchBarValue: (value: string) => void;
  placeholder?: string;
}

export const SearchBar = ({ setSearchBarValue, placeholder = 'Search Assets' }: SearchBarProps) => {
  let debounceTimeout: any;

  const onSearch = (e: any) => {
    clearInterval(debounceTimeout);
    setSearchBarValue(e.target.value);
  };

  const onSearchChange = (e: any) => {
    clearInterval(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      onSearch(e);
    }, 500);
  };

  return (
    <Input placeholder={placeholder} onChange={onSearchChange} onPressEnter={onSearch} prefix={<SearchOutlined />} />
  );
};
